import { IBreadcrumbItem } from "@fluentui/react/lib/Breadcrumb";
import { Location } from "history";
import { IOrgConfig } from "../types";

/**
 * Parameters required to build AccountAdminApp breadcrumb
 */
export interface AccountAdminAppBreadcrumbParams {
    customerTitle: string;
    appName: string;
    location: Location;
    history: any;
    orbConfig: IOrgConfig;
}

/**
 * Builds breadcrumb items for AccountAdminApp
 */
export const buildAccountAdminAppBreadcrumb = (
    params: AccountAdminAppBreadcrumbParams
): IBreadcrumbItem[] => {

    const { customerTitle, appName, location, history, orbConfig } = params;
    const items: IBreadcrumbItem[] = [];
    //console.log(orbConfig);

    // --------------------------------------------------------
    // ROOT ITEMS
    // --------------------------------------------------------
    items.push({
        text: 'ZedX Apps',
        key: "root",
        onClick: () => history.push("/")
    });

    items.push({
        text: appName,
        key: "app",
        onClick: () => history.push("/admin/welcome")
    });

    // --------------------------------------------------------
    // DETERMINE CURRENT PATH
    // --------------------------------------------------------
    let path = location.pathname || "";
    if ((!path || path === "/") && location.hash) {
        path = location.hash.replace(/^#/, "").split("?")[0].split("#")[0];
    }

    // --------------------------------------------------------
    // ROUTE-SPECIFIC BREADCRUMB ITEMS
    // --------------------------------------------------------
    switch (path) {
        case "/admin/welcome":
            items.push({ text: "Welcome", key: "welcome", isCurrentItem: true });
            break;
        case "/admin/organisation-details":
            items.push({ text: "Organisation Details", key: "organisation-details", isCurrentItem: true });
            break;
        case "/admin/groups":
            items.push({ text: orbConfig.OrgL1LabelP, key: "groups", isCurrentItem: true });
            break;
        case "/admin/directorates":
            items.push({ text: orbConfig.OrgL2LabelP, key: "directorates", isCurrentItem: true });
            break;
        case "/admin/divisions":
            items.push({ text: orbConfig.OrgL3LabelP, key: "divisions", isCurrentItem: true });
            break;
        case "/admin/locations":
            items.push({ text: "Locations", key: "locations", isCurrentItem: true });
            break;
        case "/admin/users":
            items.push({ text: "Users", key: "users", isCurrentItem: true });
            break;
        case "/admin/zedx-user-groups":
            items.push({ text: "User Groups", key: "zedx-user-groups", isCurrentItem: true });
            break;
        case "/admin/user-groups":
            items.push({ text: "User Groups", key: "user-groups", isCurrentItem: true });
            break;
        case "/admin/user-partner-organisations":
            items.push({ text: "User Partner Organisations", key: "user-partner-organisations", isCurrentItem: true });
            break;
        case "/admin/manage-emails":
            items.push({ text: "Manage Emails", key: "manage-emails", isCurrentItem: true });
            break;
        case "/admin/email-templates":
            items.push({ text: "Email Templates", key: "email-templates", isCurrentItem: true });
            break;
        case "/admin/logs":
            items.push({ text: "Logs", key: "logs", isCurrentItem: true });
            break;
        case "/admin/dev-test":
            items.push({ text: "Dev Test", key: "dev-test", isCurrentItem: true });
            break;
        case "/admin/benefit-types":
            items.push({ text: "Benefit Types", key: "benefit-types", isCurrentItem: true });
            break;
        case "/admin/customFields":
            items.push({ text: "Custom Fields", key: "customFields", isCurrentItem: true });
            break;
        case "/admin/reporting-frequencies":
            items.push({ text: "Reporting Frequencies", key: "reporting-frequencies", isCurrentItem: true });
            break;
        case "/admin/risk-types":
            items.push({ text: "Risk Types", key: "risk-types", isCurrentItem: true });
            break;
        case "/admin/risk-discussion-forums":
            items.push({ text: "Risk Discussion Forums", key: "risk-discussion-forums", isCurrentItem: true });
            break;
        case "/admin/units":
            items.push({ text: "Units", key: "units", isCurrentItem: true });
            break;
        case "/admin/thresholds":
            items.push({ text: "Thresholds", key: "thresholds", isCurrentItem: true });
            break;
        case "/admin/threshold-appetites":
            items.push({ text: "Threshold Appetites", key: "threshold-appetites", isCurrentItem: true });
            break;
        case "/admin/administrators":
            items.push({ text: "User Permissions", key: "administrators", isCurrentItem: true });
            break;
        case "/admin/custom-report-sections":
            items.push({ text: "Custom Report Sections", key: "custom-report-sections", isCurrentItem: true });
            break;
        case "/admin/financial-risk-user-groups":
            items.push({ text: "Financial Risk User Groups", key: "financial-risk-user-groups", isCurrentItem: true });
            break;
        default:
            if (path === "/not-authorised") {
                items.push({ text: "Not Authorised", key: "not-authorised", isCurrentItem: true });
            } else {
                items.push({ text: "Not Found", key: "not-found", isCurrentItem: true });
            }
            break;
    }

    return items;
};
